import React, { useContext } from 'react'
import { CurrentProcessContext } from '../../wrappers/CurrentProcessContext'
import ProcessGrid from './Grid/ProcessGrid'
import BarFilters from './Filters/BarFilters'
import CriteriaFilter from './Filters/CriteriaFilter'
import { FilterContext } from '../../wrappers/FilterContext'

const ProcessPage = () => {
    const {
        process,
        externalDataItems,
        transitions,
        action,
        setAction,
        loading
    } = useContext(CurrentProcessContext)
    const { filters, filteredData, setFilteredData } = useContext(FilterContext)

    if (!process) {
        return null
    }

    const groups = [...new Set(transitions.map((item) => item.ActionGroup))]

    return (
        <>
            <div className="smallSection">
                <div className="">
                    <h2 className="title">{process.ProcessName} Management</h2>
                </div>
                <div className="filters smallSubSection">
                    <BarFilters
                        externalDataItems={
                            externalDataItems.length ? externalDataItems : []
                        }
                        groups={groups ? groups : []}
                    />

                    <CriteriaFilter
                        externalDataItems={externalDataItems}
                        filters={process.ProcessFilterColumns}
                    />
                </div>
                <div className="grid smallSubSection">

                    <ProcessGrid
                        attributeColumns={process.ProcessGridColumns}
                        setFilteredData={setFilteredData}
                        actioned={action}
                        setActioned={setAction}
                        filteredData={filteredData ? filteredData : []}
                        transitions={transitions ? transitions : []}
                        filters={filters}
                        processName={process.ProcessName}
                        loading={loading}
                    />
                </div>
            </div>
        </>
    )
}

export default ProcessPage
